import { Link } from "react-router-dom";
import HbeLogo from "./HbeLogo";

export default function Footer() {
  return (
    <footer
      className="mt-24 border-t border-hbe-line bg-white"
      data-testid="site-footer"
    >
      <div className="hbe-container py-12 md:py-16 grid gap-10 md:grid-cols-3">
        <div>
          <Link
            to="/"
            className="inline-flex"
            aria-label="HBE Entertainment home"
          >
            <HbeLogo variant="full" color="navy" size={72} />
          </Link>
          <p className="mt-4 text-sm text-hbe-ink/70 max-w-xs">
            Private yacht experiences in Miami. A private yacht, your people, your
            time.
          </p>
          <p className="mt-4 text-xs uppercase tracking-widest text-hbe-accent">
            Miami, Florida
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-hbe-accent">
            Explore
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <Link to="/yachts" className="text-hbe-ink/80 hover:text-hbe-primary">
                Yachts
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-hbe-ink/80 hover:text-hbe-primary">
                About
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-hbe-ink/80 hover:text-hbe-primary">
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-hbe-ink/80 hover:text-hbe-primary">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-hbe-accent">
            Booking
          </div>
          <p className="mt-4 text-sm text-hbe-ink/70">
            Minimum 4 hours. Guests up to yacht capacity. Departure details
            provided after confirmation.
          </p>
        </div>
      </div>

      <div className="border-t border-hbe-line">
        <div className="hbe-container py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-hbe-ink/60">
          <div>© {new Date().getFullYear()} HBE Entertainment. All rights reserved.</div>
          <div className="text-hbe-ink/50">
            Demo imagery — replace before launch.
          </div>
        </div>
      </div>
    </footer>
  );
}
